import React from 'react';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ExperimentOutlined } from '@ant-design/icons';
import '../css/NotFound.css';

const NotFound = () => (
  <section className="notfound-section">
    <Helmet>
      <title>找不到頁面 - 湯武生技</title>
      <meta name="description" content="您所尋找的頁面不存在。" />
      <meta name="robots" content="noindex" />
    </Helmet>

    <div className="container-narrow notfound-container">
      <div className="notfound-icon-wrap">
        <ExperimentOutlined className="notfound-icon" />
      </div>

      <div className="notfound-code">404</div>
      <h1 className="title-en notfound-subtitle">Not Found</h1>

      <p className="content-ch notfound-message">
        這個頁面不在我們的配方裡，<br />
        可能已被移除，或是網址有誤。
      </p>
    </div>
  </section>
);

export default NotFound;
